<template>
  <div v-if="pagination.pages > 1" class="d-flex">
    <div v-for="page in enablePages" :key="page" class="d-flex justify-content-center align-items-center">
      <div v-if="previousEllipsisPage == page" class="ellipsis">…</div>
      <div
        :class="['pagination-item', { 'disabled': pagination.current === page }]"
        @click="changePage(page)"
      >
        {{ page }}
      </div>
      <div v-if="nextEllipsisPage == page" class="ellipsis">…</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProaListPagination',
  props: {
    pagination: Object
  },
  computed: {
    previousEllipsisPage: function() {
      if (this.pagination.pages <= 5 || this.pagination.current <= 2) {
        return null
      } else if (this.pagination.pages - this.pagination.current <= 2) {
        return this.pagination.pages - 3
      } else {
        return this.pagination.current
      }
    },
    nextEllipsisPage: function() {
      if (this.pagination.pages <= 5 || this.pagination.pages - this.pagination.current <= 3) {
        return null
      } else if (this.pagination.current == 1) {
        return this.pagination.current + 3
      } else {
        return this.pagination.pages - (this.pagination.pages - this.pagination.current - 2)
      }
    },
    enablePages: function() {
      if (this.pagination.pages <= 5) {
        return [...Array(this.pagination.pages).keys()].map(i => ++i)
      } else {
        if (this.pagination.current == 1) {
          return [...Array(this.pagination.pages).keys()].map(i => ++i).filter(i => i <= 4 || i == this.pagination.pages)
        } else if (this.pagination.current == this.pagination.pages) {
          return [...Array(this.pagination.pages).keys()].map(i => ++i).filter(i => i >= this.pagination.pages - 3 || i == 1)
        } else {
          return [...Array(this.pagination.pages).keys()].map(i => ++i).filter(i => {
            return i == 1 ||
                   i == this.pagination.pages ||
                   i == this.pagination.current ||
                   (this.pagination.current < i && i - this.pagination.current <= 2) ||
                   (this.pagination.pages - this.pagination.current <= 2 && this.pagination.pages - 3 <= i)
          })
        }
      }
    }
  },
  methods: {
    changePage: function(page) {
      this.$emit('changePage', page)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.pagination-item {
  width: 34px;
  height: 34px;
  border: 1px solid $dark-border-color;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &.disabled {
    background-color: $light-border-color;
    pointer-events: none;
  }

  &:hover {
    background-color: $light-gray-color;
  }
}

.pagination-item, .ellipsis {
  margin-right: 5px;
  color: #666666;
  font-size: 13px;
}

</style>
